import axios from "axios";
import {buildDseQuery} from "utils/queryUtils";

export const findIdpAdminEventLogs = (headers, params) => {
    let query = buildDseQuery(params, []);
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/idp-admin-event-logs${query}`, {
        headers
    })
}
